// @core/api/endpoints/secret/delete_encryption_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Delete encryption key
 * Permanently deletes an encryption key and all its versions. Only works if deletion_allowed is true on the key. This operation is irreversible.
 */
export async function DeleteEncryptionKey(
  engine_id: string,
  key_name: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
